<script setup lang="ts">
import SuccessFormIcon from '@/assets/icons/success-form.svg'
import Button from '@/components/common/BaseButton.vue'

defineEmits<{ close: [] }>()

withDefaults(
  defineProps<{
    message?: string
    withCloseButton?: boolean
    successMessageClasses?: string
  }>(),
  {
    withCloseButton: true,
    defaultMessageClasses: '',
    message:
      'Thank you for contacting us, our team will be in touch with you shortly.',
  },
)
</script>

<template>
  <div
    class="flex flex-col items-center h-full justify-center gap-y-10"
    :class="successMessageClasses"
  >
    <div class="flex flex-col items-center gap-y-10">
      <SuccessFormIcon />
      <span class="font-semibold text-center">{{ message }}</span>
    </div>
    <div
      v-if="withCloseButton"
      class="flex flex-col items-center gap-y-2 w-full"
    >
      <Button class="!w-full" @click="$emit('close')">Close</Button>
    </div>
  </div>
</template>
